export default __webpack_public_path__ + "static/media/send-icon.22fa51b0.svg";